import {NavLink as RouterNavLink} from 'react-router-dom';

export default function NavLink({children, to, className = "", ...others}: React.ComponentProps<typeof RouterNavLink>) {
    return (
        <RouterNavLink {...others} to={to} className={className}>
            {children}
        </RouterNavLink>
    );
}
